export const defaultPreferences = {
  id: 1,
  positionsClustering: true,
  showTracks: true,
  showMarkers: true,
  tracksArrows: true,
  scaleBar: true,
  mapMostRecentAmount: 50,
  mapProvider: 0,
  newestMarkerIcon: 1,
  newestMarkerColor: 'ff0000',
  oldestMarkerIcon: 1,
  oldestMarkerColor: 'ffff00',
  positionsPrecision: 3,
  mapLightConditionIconToggle: false,
  mapSpeciesIconToggle: true,
};
